/**
 * hidden-input.js
 */

import React from 'react';
import { 
  InputBase,
} from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import get from 'lodash.get';


export default function HiddenInput(props) {
  const {
    formContext: formContextProp,
    name,
    rules,
    defaultValue,
    errorRef,
    setValueAs,
  } = props;

  const formContextDefault = useFormContext();
  const formContext = formContextProp || formContextDefault;
  const hasError = Boolean(get(formContext.formState.errors, name));


  // when error ref is provided we scroll it into view if we get an error
  React.useEffect(() => {
    if (hasError && errorRef) {
      errorRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [hasError, errorRef]);


  return (
    <div style={{ display: 'none' }}>
      <Controller
        control={formContext.control}
        name={name}
        rules={rules}
        defaultValue={defaultValue}
        render={({ field: { ref, onChange, ...inputProps } }) => (
          <InputBase
            inputRef={ref}
            value={inputProps.value || ''}
            onChange={(e) => onChange(setValueAs ? setValueAs(e.target.value) : e.target.value)}
            type="hidden"
          />
        )}
      />
    </div>
  );
}